// Converte um perfil do MakerWorld (vindo do backend) no MESMO formato de
// placas que a Calculadora já usa depois de ler um 3MF — assim o resto do
// fluxo (resumirPlacas, filamentos detectados, cor mais próxima do estoque)
// funciona sem nenhum caminho especial:
//   [{ index, predictionSeconds, weightG, filaments: [{ id, usedG, color, type }] }]
// `indices` = placas escolhidas (padrão: todas). Perfil sem detalhamento por
// placa vira uma placa única com os totais.
export function placasDoPerfil(perfil, indices) {
  if (!perfil) return [];
  if (!perfil.placas?.length) {
    return [{
      index: 1, predictionSeconds: perfil.segundos, weightG: perfil.pesoG,
      filaments: (perfil.filamentos || []).map((f, i) => ({ id: i + 1, usedG: f.gramas, color: f.cor, type: f.tipo })),
    }];
  }
  const escolhidas = new Set(indices ?? perfil.placas.map(p => p.index));
  return perfil.placas.filter(p => escolhidas.has(p.index)).map(p => ({
    index: p.index, predictionSeconds: p.segundos, weightG: p.pesoG,
    filaments: p.filamentos.map(f => ({ id: f.id, usedG: f.gramas, color: f.cor, type: f.tipo })),
  }));
}

// 95118 -> "26h 25min"; sem dado -> "—"
export function duracaoLegivel(segundos) {
  if (!Number.isFinite(segundos) || segundos <= 0) return "—";
  const min = Math.round(segundos / 60);
  return min >= 60 ? `${Math.floor(min / 60)}h ${String(min % 60).padStart(2, "0")}min` : `${min}min`;
}
